import {FC} from 'react'

import {IconSize} from '@/theme/icons'
import {theme} from '@/theme/theme'

import {Icon, IconProps} from './Icon'

export const DictionaryIcon: FC<IconProps> = ({
  color = theme.palette.text.primary,
  size = IconSize.medium,
}) => (
  <>
    <Icon size={size}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.3467 9.97302L12.7746 11.1647C12.8695 11.429 13.1579 11.5653 13.4189 11.4692C13.6798 11.373 13.8144 11.0808 13.7195 10.8165L11.8467 5.60079C11.7172 5.2401 11.3788 5 10.9999 5C10.621 5 10.2826 5.24009 10.1531 5.60079L8.2803 10.8165C8.18539 11.0808 8.31997 11.373 8.58089 11.4692C8.84181 11.5653 9.13026 11.429 9.22517 11.1647L9.65305 9.97302H12.3467ZM11.981 8.95449L10.9999 6.22208L10.0188 8.95449H11.981Z"
          fill={color}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 16.5V3.25C2 2.00736 3.00736 1 4.25 1H15.75C16.9926 1 18 2.00736 18 3.25V14.75C18 15.1642 17.6642 15.5 17.25 15.5C16.7259 15.5 16.3 15.919 16.3 16.5C16.3 17.081 16.7259 17.5 17.25 17.5C17.6642 17.5 18 17.8358 18 18.25C18 18.6642 17.6642 19 17.25 19H4.5C3.11929 19 2 17.8807 2 16.5ZM4.25 2.5H4.5V14C4.14445 14 3.80623 14.0742 3.5 14.208V3.25C3.5 2.83579 3.83579 2.5 4.25 2.5ZM5.5 14V2.5H15.75C16.1642 2.5 16.5 2.83579 16.5 3.25V14H5.5ZM3.5 16.5C3.5 15.9477 3.94772 15.5 4.5 15.5H15.0007C14.8709 15.8083 14.8 16.1472 14.8 16.5C14.8 16.8528 14.8709 17.1917 15.0007 17.5H4.5C3.94772 17.5 3.5 17.0523 3.5 16.5Z"
          fill={color}
        />
      </svg>
    </Icon>
  </>
)
